module.exports = __webpack_public_path__ + "img/banking-compare.cacebb2.png";